<template>
  <div class="slot">
    <div class="reel" :style="reelStyle">
      <div v-for="n in numbers" :key="n">
        {{ leadingNumber(n) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    duration: {
      type: Number,
      default: 500,
    },
    range: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    numbers() {
      return Array.from({ length: this.range + 1 }, (_, i) => i);
    },
    reelStyle() {
      const offset = -this.value * 1;
      return {
        transform: `translateY(${offset}em)`,
      };
    },
  },
  methods: {
    leadingNumber(value) {
      return String(value).padStart(2, '0');
    },
  },
};
</script>

<style scoped>
.slot {
  height: 1em;
  overflow: hidden;
  font-size: 1em;
  line-height: 1em;
}
.reel {
  display: inline-block;
  transition: transform 1000ms ease-out;
}
@keyframes spin {
  0% { transform: translateY(0); }
}
</style>
